import { SelectChangeEvent } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import DefaultInput from "../../../../../../common/components/default_input";

// Header Alvenaria estrutural Lista.
 

type Props = {
  dataReceberDe: Date | null;
  dataReceberAte: Date | null;
  fornecedor: string | null;
  tipoBloco: string | null;
  NroNotaFiscal: string | null;
  onClearFilters: () => void;
  handleDataReceberRangeChange: (v: Date | null, x: Date | null) => void;
  handleFornecedorChange: (v: string) => void;
  handleTipoBlocoChange: (v: string) => void;
  handleNroNotaFiscalChange: (v: string) => void;

};


export const Header = ({ dataReceberDe, dataReceberAte,fornecedor,tipoBloco,NroNotaFiscal, onClearFilters, handleDataReceberRangeChange,handleFornecedorChange,handleTipoBlocoChange, handleNroNotaFiscalChange
}: Props) => {
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);
 return (
    <>
      <CascateList title="Filtros" defaultOpen>
        <div className="w-full flex flex-col gap-6">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2">
            <div className="w-full">
              <DefaultDateRangePickerInput
                label='Data de'
                dataDe={dataReceberDe ?? null}
                dataAte={dataReceberAte ?? null}
                onChange={async (start, end) => {
                  handleDataReceberRangeChange(start, end)
                }}
              />
            </div>

            <div className="w-full">
              <DefaultInput
                name='Fornecedor'
                label='Fornecedor'
                value={fornecedor} 
                onChangeValue={handleFornecedorChange}
              />
            </div>
            <div className="w-full">
              <DefaultInput
                name='TipoBloco'
                label='Tipo de Bloco'
                value={tipoBloco}
                onChangeValue={handleTipoBlocoChange}
              />
            </div>

            <div className="w-full">
              <DefaultInput
                name='NroNotaFiscal'
                label='Nº da Nota Fiscal'
                value={NroNotaFiscal}
                onChangeValue={handleNroNotaFiscalChange}
              />
            </div>
          </div>
          <div className="w-full flex justify-end">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </CascateList>
    </>
  );
}